import { render, staticRenderFns } from "./LineItemDataView.vue?vue&type=template&id=06b1c833&scoped=true&"
import script from "./LineItemDataView.vue?vue&type=script&lang=js&"
export * from "./LineItemDataView.vue?vue&type=script&lang=js&"
import style0 from "./LineItemDataView.vue?vue&type=style&index=0&id=06b1c833&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b1c833",
  null
  
)

export default component.exports